export { default } from './SectionOverviewIntroAppInfoContainer';
